import { take, fork, all, put } from 'redux-saga/effects';
import {
  LOAD_APP,
  loadApp,
} from '../actions/index';

export function* loadAppRequest() {
  yield put(loadApp.success());
}
function* watchLoadApp() {
  while (true) {
    yield take(LOAD_APP.REQUEST);
    yield fork(loadAppRequest);
  }
}

export default function* appSaga() {
  yield all([
    fork(watchLoadApp),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/app.js